import React from 'react';
import { BRAND, isBrandOV, isMarketGB } from '../../../constants/main';
import { EngineSelectStyledAC } from './AC/EngineSelectStyled.AC';
import { EngineSelectStyledAP } from './AP/EngineSelectStyled.AP';
import { EngineSelectStyledDS } from './DS/EngineSelectStyled.DS';
import { EngineSelectStyledOV } from './OV/EngineSelectStyled.OV';
import { EngineSelectStyledOVGB } from './OV/GB/EngineSelectStyled.OV.GB';
import { EngineSelectStyled } from './EngineSelectStyled';
import { SC } from '../../../styles/theme';

export type EngineSelectProps = SC & {};

const EngineSelect = (props: EngineSelectProps) => {
    if (isBrandOV) return isMarketGB ? <EngineSelectStyledOVGB {...props} /> : <EngineSelectStyledOV {...props} />;
    if (BRAND === 'AC') return <EngineSelectStyledAC {...props} />;
    if (BRAND === 'AP') return <EngineSelectStyledAP {...props} />;
    if (BRAND === 'DS') return <EngineSelectStyledDS {...props} />;
    return <EngineSelectStyled {...props} />;
};

export default EngineSelect;
